import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import commonEN from './en/common.json';
import authEN from './en/auth.json';
import validationEN from './en/validation.json';

const resources = {
  en: {
    common: commonEN,
    auth: authEN,
    validation: validationEN,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  defaultNS: 'common',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
